<template>
  <div>
    <vs-tabs :value="3">
      <vs-tab label="폐암검진결과" @click.prevent="onClickTab(0)" />
      <vs-tab label="폐암검진결과 엑셀 업로드" @click.prevent="onClickTab(1)" />
      <vs-tab label="폐암정밀검진" @click.prevent="onClickTab(2)" />
      <vs-tab label="폐암정밀검진 엑셀 업로드"/>
    </vs-tabs>

    <vx-card class="w-full">
      <div class="flex justify-between items-center">
        <h4>폐암정밀검진 엑셀 업로드</h4>
        <vs-button color="secondary" @click="onClickSave">저장</vs-button>
      </div>
      <p class="mt-6 mb-5">
        ※ 엑셀 업로드 시, "폐암검진결과" 메뉴에 이상소견자(4A, 4B, 4X)로 등록 된 종사자만 검색됩니다.
      </p>

      <!-- 기본정보 -->
      <field-select-module class="mt-4" v-model="form.stdInfo" title="작성자 정보" :board="board" :types="['department', 'com_name', 'rank', 'writer_name', 'regist']" />

      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>파일 업로드</div>
          <div>
            <vs-button color="secondary" type="border" href="https://jnedu.maot.co.kr:8080/storage/app/media/%EC%95%88%EC%A0%84%EB%B3%B4%EA%B1%B4%EC%8B%9C%EC%8A%A4%ED%85%9C_%ED%8F%90%EC%95%94%EC%A0%95%EB%B0%80%EA%B2%80%EC%A7%84%EC%84%9C%EC%8B%9D_%EC%97%91%EC%85%80%EC%97%85%EB%A1%9C%EB%93%9C_rev.1.0.xlsx">엑셀 템플릿 다운로드</vs-button>
            <vs-button color="secondary" class="ml-2" @click="onClickExcelUpload"> 작성 엑셀 업로드 </vs-button>
            <input v-show="false" ref="excelInput" type="file" @change="readFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
          </div>
        </div>
      </div>

      <!-- 등록 대상 종사자 정보 -->
      <div>
        <div class="flex justify-between items-center mt-6 mb-4">
          <h5><i class="dot"></i> 등록 대상 종사자 정보</h5>
          <vs-button color="secondary" type="border" @click="onClickCheckRemove">선택삭제</vs-button>
        </div>
        <div style="max-height: 1070px; overflow-y: auto">
          <table>
            <colgroup>
              <col width="60" />
              <col width="60" />
            </colgroup>
            <thead>
            <th><vs-checkbox :value="0 < excelData.length && excelData.length === checkList.length" @click.native="checkAll" class="check" /></th>
            <th>검진구분</th>
            <th>No.</th>
            <th>설립</th>
            <th>구분(급별)</th>
            <th>학교(기관)명</th>
            <th>이름</th>
            <th>직종</th>
            <th>검진일</th>
            <th>정밀검진 결과</th>
            <th>비고</th>
            <th>수정/삭제</th>
            </thead>
            <tbody>
            <tr v-for="(excel, row_i) in excelData" :key="`${row_i}_${excel[0]}`">
              <td><vs-checkbox :vs-value="row_i" v-model="checkList" class="check" /></td>
              <td v-for="(_num) in [0, 1, 2, 10, 3, 4, 5, 7, 8, 9]" :key="`${row_i}_${excel[0]}_${_num}`">
                <div v-if="editExcelIndex === row_i" class="p-1">
                  <DateSelector v-if="excelDataTypes[_num] === 'date'" v-model="editExcelData[_num]" class="w-full" />
                  <!-- 구분(급별) 수정불가 -->
                  <ml-input v-else-if="_num === 10" v-model="editExcelData[_num]" class="w-full" disabled/>
                  <ml-input v-else v-model="editExcelData[_num]" class="w-full" />
                </div>
                <div v-else>
                  <p v-if="_num === 3" class="flex justify-center align-middle">{{ excel[_num] || "-" }}
                    <svg v-if="!!errorMSG[row_i]" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.83325 17C14.2515 17 17.8333 13.4183 17.8333 9C17.8333 4.58172 14.2515 1 9.83325 1C5.41497 1 1.83325 4.58172 1.83325 9C1.83325 13.4183 5.41497 17 9.83325 17Z" fill="#FFDADA"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6332 5.8C10.6332 5.35817 10.275 5 9.8332 5C9.39138 5 9.0332 5.35817 9.0332 5.8V9C9.0332 9.44183 9.39138 9.8 9.8332 9.8C10.275 9.8 10.6332 9.44183 10.6332 9V5.8ZM9.82922 11.4C9.38959 11.4 9.0332 11.7582 9.0332 12.2C9.0332 12.6418 9.38959 13 9.82922 13H9.83718C10.2768 13 10.6332 12.6418 10.6332 12.2C10.6332 11.7582 10.2768 11.4 9.83718 11.4H9.82922Z" fill="#EA5455"/>
                    </svg>
                    <svg v-else width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.83325 17C14.2515 17 17.8333 13.4183 17.8333 9C17.8333 4.58172 14.2515 1 9.83325 1C5.41497 1 1.83325 4.58172 1.83325 9C1.83325 13.4183 5.41497 17 9.83325 17Z" fill="#CAF9DF"/>
                      <path d="M14.4769 5.94823C14.3746 5.85121 14.2371 5.79688 14.0939 5.79688C13.9507 5.79688 13.8133 5.85121 13.711 5.94823L8.78745 10.8201L6.81796 8.8078C6.77094 8.7471 6.71102 8.69689 6.6422 8.66058C6.57338 8.62426 6.49734 8.60267 6.41915 8.59729C6.34097 8.59191 6.26246 8.60286 6.18903 8.62939C6.1156 8.65592 6.04892 8.69743 5.9935 8.75107C5.93807 8.80472 5.89522 8.86927 5.86782 8.94035C5.84041 9.01143 5.82907 9.08736 5.83463 9.16304C5.84018 9.23872 5.86249 9.31236 5.9 9.37897C5.93752 9.44559 5.98943 9.50362 6.05213 9.54914L8.45916 11.9851C8.45916 12.091 8.67803 12.1969 8.78745 12.1969C8.87238 12.1969 8.9561 12.1777 9.03206 12.141C9.10803 12.1042 9.1741 12.0508 9.22506 11.9851L14.4769 6.68961C14.5771 6.59062 14.6333 6.45753 14.6333 6.31892C14.6333 6.18031 14.5771 6.04722 14.4769 5.94823Z" fill="#28C76F"/>
                    </svg>
                  </p>
                  <p v-else class="flex justify-center align-middle">{{ excel[_num] || "-" }}</p>
                  <p v-if="_num === 3 && !!errorMSG[row_i]" class="errMsg">{{ errorMSG[row_i] }}</p>
                </div>
              </td>
              <td>
                <div class="flex justify-center gap-3">
                  <fragment v-if="editExcelIndex === row_i">
                    <button @click="onClickFinshExcelData(row_i)">
                      <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
                    </button>
                    <button @click="onClickCancelExcelData(row_i)">
                      <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
                    </button>
                  </fragment>
                  <fragment v-else>
                    <button @click="onClickEditExcelData(row_i)">
                      <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                    </button>
                    <button @click="onClickRemoveExcelData(row_i)">
                      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
                    </button>
                  </fragment>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelectorMultiple";
import CompanySelector from "@/components/selector/CompanySelector";
import DateSelector from "@/components/selector/DateSelector";
import XLSX from "xlsx";
import moment from "moment";
import HttpRequest from "@/util/HttpRequest";
import { getFieldLabel } from "@/util/DataUtil";

export default {
  components: {
    FieldSelectModule,
    FieldSelector,
    CompanySelector,
    DateSelector,
  },
  data() {
    return {
      board: {
        projectTitle: this.$store.state.project.projectInfo.field_name,
        writer: {}, //작성자 정보
        readonly: false, // 읽기전용인가
        isPrint: false,
        viewSaveBtn: true,
        viewRemoveBtn: true,
      },

      form: {
        stdInfo: {},
      },

      editExcelIndex: null,
      editExcelData: [],
      excelData: [],
      excelDataTypes: [
        'string', 'string', 'string', 'string', 'string',
        'string', 'phone', 'date', 'string'],
      checkList: [],

      errorMSG: [],

      // 문서별 체크 리스트
      checkPostList: {},
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    myInfo() {
      return this.$store.state.member.memberInfo;
    },
    getFieldLabel() {
      return getFieldLabel();
    },
  },
  watch: {
    excelData () {
      this.checkExcelData();
    },
  },
  async created() {
    await this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "보건관리 현황" }, { title: "폐암검진(연도별)", active: true }]);
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      await this.$store.dispatch("USER_INFO");
      this.board.writer = {
        id: this.$store.state.auth.userInfo.id,
        name: this.$store.state.auth.userInfo.name,
        company_id: this.$store.state.auth.userInfo.company_id,
        department: this.$store.state.auth.userInfo.department,
        section: this.$store.state.auth.userInfo.section,
        rank: this.$store.state.auth.userInfo.rank,
        com_name: "",
      };

      await this.$store.dispatch("company/LOAD_COMPANY", {
        companyId: this.board.writer.company_id,
      });
      this.board.writer.com_name = this.$store.state.company.companyInfo.com_name;
      if (!this.board.writer.section) {
        this.board.writer.section = this.board.writer.com_name;
      }
    },
    onClickExcelUpload() {
      const excelInput = this.$refs.excelInput;
      excelInput.value = null;
      excelInput.click();
    },
    // 엑셀데이터 파싱
    readFile(event) {
      // get File object from input tag
      const file = event.target.files[0];
      const fileName = file.name;

      // declare FileReader, temp result
      const reader = new FileReader();
      let tmpResult = {};

      // if you use "this", don't use "function(e) {...}"
      reader.onload = (e) => {
        let data = e.target.result;
        data = new Uint8Array(data);
        // get excel file
        let excelFile = XLSX.read(data, { type: "array", cellDates: true });

        // get prased object
        excelFile.SheetNames.forEach(function (sheetName) {
          const roa = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], { header: 1 });
          if (roa.length) tmpResult[sheetName] = roa;
        });
        let _data = tmpResult.Sheet1.filter((data, data_i) => data_i !== 0 && 0 < data.length);
        if (_data.length > 0) _data.shift();
        _data = _data.map((row) => {
          // 0 검진구분
          // 1 No.
          // 2 설립
          // 3 학교(기관)명
          // 4 이름
          // 5 직종
          // 6 연락처
          // 7 검진일
          // 8 정밀검진 결과
          // 9 비고
          return row.map((item, item_i) => {
            let _item = item;
            if (this.excelDataTypes[item_i] === "phone") _item = this.setPhone(_item);
            else if (this.excelDataTypes[item_i] === "date") _item = this.setMoment(_item);
            return _item;
          });
        });
        this.excelData = [...this.excelData, ..._data];
      };
      reader.readAsArrayBuffer(file);

    },

    async checkExcelData () {
      // 검색할 학교이름 리스트 만들기
      for (const row of this.excelData) {
        const userName = row[4];
        const fieldName = row[3];
        const workType = row[5];
        const opt = row[0]; //이상소견

        if (!this.checkPostList[`${userName}_${fieldName}_${workType}_${opt}`]) {
          this.loading(true);
          this.checkPostList[`${userName}_${fieldName}_${workType}_${opt}`] = -1;

          const options = {
            projectId: this.projectId,
            boardId: 502,
            page: 1,
            perPage: 10,
            orderTarget: 'created_at',
            conditions:[
              { operator: "LIKE", value: `${fieldName}`, key: "body.inputA_3",}, // 학교(기관)명
              { operator: "LIKE", value: `${userName}`, key: "body.inputA_8",}, // 이름
              { operator: "LIKE", value: `${workType}`, key: "body.inputA_6",}, // 직종
              { operator: "LIKE", value: `${opt}`, key: "body.inputB_2_value",}, // 이상소견
            ],
          };
          const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
          if (response.data.length > 0) {
            const post = response.data[0];
            const body = JSON.parse(post.post_content).body;
            const inputB_1 = body.inputB_1; // 검진일
            const inputB_4 = body.inputB_4; // 판정구분 권고사항
            const inputB_5 = body.inputB_5; // 폐결절외 권고사항
            const cat3 = body.inputA_2; // 구분(급별)
            row[10] = cat3;
            row[11] = inputB_1;
            row[12] = inputB_4;
            row[13] = inputB_5;
            this.checkPostList[`${userName}_${fieldName}_${workType}_${opt}`] = body;
          }
          this.loading(false);
        }
      }

      // 등록가능한 상태인지 확인
      const errorMSG = [];
      for (let i=0; i<this.excelData.length; i++) {
        const row = this.excelData[i];
        const userName = row[4];
        const fieldName = row[3];
        const workType = row[5];
        const opt = row[0]; //이상소견
        if (!this.checkPostList[`${userName}_${fieldName}_${workType}_${opt}`] || this.checkPostList[`${userName}_${fieldName}_${workType}_${opt}`] <= 0) {
          errorMSG[i] = "입력된 데이터가 검색되지 않습니다.";
        } else {
          errorMSG[i] = "";
        }
      }
      this.errorMSG = errorMSG;
    },
    setMoment(date) {
      let _date = date;
      if (typeof _date === "number") _date = `${_date}`;
      if (typeof _date === "string" && !_date.includes("-")) _date = `${_date.slice(0, 4)}-${_date.slice(4, 6)}-${_date.slice(6, 8)}`;
      return moment(_date).add(1, "days").format("YYYY-MM-DD");
    },
    setPhone(data) {
      let _data = `${data}`;
      if (typeof data === "number" && _data.length === 10 && _data.charAt(0) !== "0") _data = `0${_data}`;
      return _data.replace(/^(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    },
    onClickEditExcelData(index) {
      this.editExcelData = JSON.parse(JSON.stringify(this.excelData[index]));
      this.editExcelIndex = index;
    },
    async onClickFinshExcelData(index) {
      const _data = this.editExcelData.map((item, item_i) => {
        if (this.excelDataTypes[item_i] === "date") return !!item.trim() ? moment(item).format("YYYY-MM-DD") : "";
        else return item;
      });
      this.$set(this.excelData, index, _data);
      this.onClickCancelExcelData();
    },
    onClickCancelExcelData(index) {
      this.editExcelData = [];
      this.editExcelIndex = null;
      this.checkExcelData();
    },
    onClickRemoveExcelData(index) {
      this.excelData.splice(index, 1);
      this.checkExcelData();
    },
    checkAll() {
      if (0 < this.excelData.length && this.excelData.length === this.checkList.length) this.checkList = [];
      else this.checkList = this.excelData.map((_, i) => i);
    },
    onClickCheckRemove() {
      if (this.checkList.length < 1) return;
      this.excelData = this.excelData.filter((_, i) => !this.checkList.includes(i));
      this.checkList = [];
      this.checkExcelData();
    },
    async onClickSave() {
      if (this.errorMSG.length < 1) return;

      let next = true;
      for (const error of this.errorMSG) {
        if (!!error) {
          next = false;
          break;
        }
      }

      if (next) {

        for (const data of this.excelData) {
          this.loading(true);
          const form = {
            stdInfo: {},
            fileList: [],

            inputA_1: '',
            inputA_2: data[10], // 구분(급별)
            inputA_3: data[3], //3 학교(기관)명
            inputA_4: '',
            inputA_5: '',
            inputA_6: data[5], //5 직종
            inputA_7: '',
            inputA_8: data[4], //4 성명
            inputA_9: '',
            inputA_10: data[2], //2 설립: 공립, 국립, 사립
            inputA_11: '',

            inputB_1: data[11], // 건강검진 검진일
            inputB_2: '없음', // 이상소견
            inputB_2_value: data[0], //0
            inputB_3: '',
            inputB_4: data[12], // 판정구분에 따른 권고사항
            inputB_5: data[13], // 폐결절외 기타 권고사항

            inputC_1: data[7], //7 정밀검진 검진일
            inputC_2: data[8], //8 정밀검진 결과
            inputC_3: data[9], //9 비고
          }

          form.inputB_2 = form.inputB_2_value ? "있음" : "없음";

          await this.saveBoardPost("create", form).catch((err) => {
            this.customAlert(err.response.data.message);
            next = false;
          });
          this.loading(false);
        }
        this.customAlert("등록되었습니다.", "완료");
        this.excelData = [];
      } else {
        this.customAlert("검색되지 않은 데이터가 있습니다. 확인 후 다시 시도해주시기 바랍니다.");
      }
    },
    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: !!title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },
    onClickTab(tabIndex) {
      if (tabIndex === 0) {
        this.$router.push({ name: "list|tab", params: { boardId: 502 } });
      } else if (tabIndex === 1) {
        this.$router.push({ name: "lungcancer502"});
      } else if (tabIndex === 2) {
        this.$router.push({ name: "list|tab", params: { boardId: 503 } });
      } else if (tabIndex === 3) {
        this.$router.push({ name: "lungcancer503"});
      }
    },
    async saveBoardPost(type, body) {
      const form = {
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
        },
        body,
      };
      form.header.full = `${form.header.year}-${form.header.month > 9 ? form.header.month : `0${form.header.month}`}-01`;

      const projectId = this.projectId;
      const boardId = 503;
      const title = "폐암정밀검진";
      const content = JSON.stringify(form);

      if (type === "create") {
        await this.$store.dispatch("board/CREATE_POST", {
          projectId,
          boardId,
          title,
          content,
        });
      } else if (type === "update") {
        const postId = this.postId;
        await this.$store.dispatch("board/UPDATE_POST", {
          projectId,
          boardId,
          postId,
          title,
          content,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    text-align: center;
    padding: 0;
  }

  th {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;

    background: #fafafa;
    border-top: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;

    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }

  .check {
    justify-content: center !important;
    ::v-deep {
      span {
        margin: 0;
      }
    }
  }
}
.errMsg {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: #ea5455;
  margin-top: 2px;
}
</style>
